<app-mrp-scrolltop></app-mrp-scrolltop>
<!-- Main -->
<main id="main" class="wrapper">
  <article class="inner">
    <div class="content">
      <h1 class="visually-hidden">Evening Zoom Classes - Robert's Rules Training</h1>
      <header><h2>Zoom Classes</h2></header>
      <p>The best way to fit training into a busy schedule. See <a class="class-link" (click)="scrollTo('class-dates')"><b>Class Dates </b></a>below.</p>


      <p>You still do. You still speak. You still learn. You will leave with new parliamentary skills.</p>

      <p><b>Zoom Classes are 7PM - 8:30PM </b> </p>


      <blockquote>"You need to take this class."
        <p>- Dennis Krajniak, Saginaw County
          <button class="interview-button" (click)="openVideoPlayer(2)" mat-icon-button aria-label="Open video player">
            <mat-icon class="interview-icon">videocam</mat-icon>
          </button>
        </p>
      </blockquote>

      <div class="table-wrapper">
        <table>
          <tbody>
            <tr>
              <td><b>PRICE:</b></td>
              <td><B>$35</B></td>
            </tr>
            <tr>
              <td><b>PRE-REGISTRATION:</b></td>
              <td><B>$25</B> with 5 Day Advanced Purchase Coupon</td>
            </tr>
          </tbody>
        </table>
      </div>




      <!-- Table -->
      <h3>Intro To Basics Class</h3>

      <div class="table-wrapper">
        <table>
          <thead>
            <tr><th>Topic </th>
            <th>Description</th>

          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>Introduction to the Rules</td>

          </tr>
          <tr><td>2</td>
          <td>Motion Mechanics</td>

        </tr>
        <tr><td>3</td>
        <td>Ammendment Process </td>

      </tr>

    </tbody>

  </table>
</div>

<!-- Table -->
<h3>Member Rights Class</h3>

<div class="table-wrapper">
  <table>
    <thead>
      <tr><th>Topic </th>
      <th>Description</th>

    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>The Rules and Your Rights</td>

    </tr>
    <tr><td>2</td>
    <td>How to Appeal Chair Decisions</td>

  </tr>
  <tr><td>3</td>
  <td>Point of Order and Point of Information</td>

</tr>
<tr><td>4</td>
<td>Proper Chair Practices </td>

</tr>

</tbody>

</table>
</div>

<!-- Table -->
<h3>Advanced Motions Class</h3>

<div class="table-wrapper">
  <table>
    <thead>
      <tr><th>Topic </th>
      <th>Description</th>

    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>Complex Amendments</td>

    </tr>
    <tr><td>2</td>
    <td>Advanced Resolutions</td>

  </tr>
  <tr><td>3</td>
  <td>Winning Your Motion</td>

</tr>

</tbody>

</table>
</div>

<!-- Table -->
<h3>Committees Class</h3>

<div class="table-wrapper">
  <table>
    <thead>
      <tr><th>Topic </th>
      <th>Description</th>

    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>Committee Work</td>

    </tr>
    <tr><td>2</td>
    <td>Getting Work Done</td>

  </tr>
  <tr><td>3</td>
  <td>Advanced Amendments</td>

</tr>

</tbody>

</table>
</div>




</div>
</article>
</main>


<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->

<!-- Class Dates Section -->
<section  class="wrapper">
  <article id="class-dates" class="inner">
    <div class="content">

      <header ><h2>Class Dates</h2></header>

      @if (isLoading) {
        <div >
          <div class="spinner-container">
            <div class="spinner"></div>
          </div>
          <h5>Retrieving data...</h5>
        </div>
      }

      @if (!isLoading) {
        <div>
          @if (classes.length > 0) {
            <div>
              <div class="classlist-container">
                <table class="classes-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Date</th>
                      <th>Purchase</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (class of classes; track class) {
                      <tr>
                        <td (click)="gotoClass(class.item_CODE)">{{ class.productTitle }}</td>
                        <td>{{ class.eventDate }}</td>
                        <td>
                          <button class="purchase-btn" (click)="gotoClass(class.item_CODE)" > Register
                          </button>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              <p><i>NOTE: Please login 10 minutes early to register, which is mandatory, set name and locate 'Raise Hand' on your device.</i></p>
            </div>
          }
          @if (classes.length === 0 || noClassesMessage) {
            <div>
              <p>{{ noClassesMessage || 'No Zoom Classes Scheduled.' }}</p>
              <p>Check Back Soon...</p>
            </div>
          }
        </div>
      }

    </div>
  </article>
</section>


<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->

<!-- Main -->
<section id="main" class="wrapper">
  <article class="inner">
    <div class="content">

      <!-- Elements -->
      <div class="row">

        <div class="col-12-medium">

          <h3>Testimonials</h3>
          <div class="box">
            <blockquote>"The Zoom made it very convenient for me. Thank you. And thank you for taking my questions." -Allen</blockquote>
            <blockquote>"If it wasn't for the Zoom class I wouldn't have been trained in time. And you covered it really well! Thank you!." -Patricia</blockquote>
          </div>
        </div>

      </div>
    </div>
  </article>
</section>

<app-footer></app-footer>

